import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";
import { getStandardTags } from "../../store/actions/tags/tags";
import ClassifyCategory from "./classifyCategory";
import LinkDocument from "./linkDocument";
import Preview from "../documentDetails/preview/index";
import Stepper from "./stepper";
import TagsBlock from "./tagsBlock";
import "./style.css";

const Classificator = props => {
  const {
    accountantSelected,
    accountantIdSelected,
    companySelected,
    clientIdSelected,
    documentId,
    myType
  } = props;
  const auth = useSelector(state => state.auth);
  const categoryDocuments = useSelector(state => state.categoryDocuments);
  const details = useSelector(state => state.detailsDocument.info.details);
  // const detailsDocument = useSelector(state => state.detailsDocument);
  const tags = useSelector(state => state.tags);

  const [currentStep, setCurrentStep] = useState(1);
  const [etichettePersonalizzate, setEtichettePersonalizzate] = useState([]);
  const [isAllRequiredSet, setIsAllRequiredSet] = useState(false);
  // const [pageNumber, setPageNumber] = useState(1);
  const [standardTags, setStandardTags] = useState([]);
  const [typeSelected, setTypeSelected] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [dataPayload, setDataPayload] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  const updateStepAndTags = objCategory => {
    setCurrentStep(2);
    setEtichettePersonalizzate(details?.customTags || []);
    setStandardTags( details.standardTags || {});
    setTypeSelected(objCategory ? objCategory.id : "");
  };

  useEffect(() => {
    if (typeSelected !== "") return;

    if (details && categoryDocuments && typeSelected === "") {
      const docTypeValue = details.realCategory
        ? details.realCategory
        : details.standardTags.find(el => el.key === "category").value;
      const objCategory = categoryDocuments.find(elem => {
        return docTypeValue && elem.title === docTypeValue;
      });
      updateStepAndTags(objCategory);
    }
  }, [details, categoryDocuments]);

  useEffect(() => {
    if (
      typeSelected === "" ||
      tags.list.length !== 0 ||
      tags.status.ended ||
      tags.status.started ||
      tags.status.error
    )
      return;
    dispatch(getStandardTags(
      auth, companySelected, clientIdSelected, typeSelected
    ));
  }, [typeSelected]);

  const changeDocumentType = (value, e) => {
    // devo modificare i valori dentro kvags
    let objDocumentInfo = categoryDocuments.find(el => {
      return el.id === value;
    });
    let newStandardTags = [];
    newStandardTags.push({
      key: "macrocategory",
      value: objDocumentInfo.macro
    });

    newStandardTags.push({
      key: "microcategory",
      value: objDocumentInfo.micro
    });

    newStandardTags.push({
      key: "category",
      value: objDocumentInfo.title
    });

    dispatch(getStandardTags(
      auth, companySelected, clientIdSelected, value
    ));
    setCurrentStep(2);
    setIsAllRequiredSet(false);
    setStandardTags(newStandardTags);
    setTypeSelected(e.key); // è il valore che l'utente vede a video e che serve alla save
  };

  /** ho bisogno di questa function per andare direttamente al pulsante salva
   * quando ho completato tutti i campi obbligatori
   */
  const goNextStep = value => {
    setIsAllRequiredSet(value);
    setCurrentStep(isAllRequiredSet !== value ? currentStep + 1 : currentStep);
  };

  const nextStep = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    setCurrentStep(currentStep + 1);
  };

  const removeEtichettePersonalizzata = value => {
    let arrayEtichette = [...etichettePersonalizzate];
    arrayEtichette = arrayEtichette.filter(elemento => elemento !== value);

    setEtichettePersonalizzate(arrayEtichette);
  };

  const resetChange = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    setCurrentStep(1);
    setIsAllRequiredSet(false);
    setStandardTags({});
    setTypeSelected("");
  };

  const steps = [
    { number: 1, title: <FormattedMessage id="documents.classificator.step1" /> },
    { number: 2, title: <FormattedMessage id="documents.classificator.step2" /> },
    { number: 3, title: <FormattedMessage id="documents.classificator.step3" /> }
    // { number: 3, title: "Collega altro doc" }
  ];

  return tags && tags.list ? (
    <div>
      <Stepper
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        steps={steps}
      ></Stepper>
      <div style={{ display: "flex", marginBottom: "40px" }}>
        <div className="formClassificator">
          <ClassifyCategory
            changeDocumentType={changeDocumentType}
            typeSelected={typeSelected}
          />
          {currentStep > 1 ? (
            <TagsBlock
              documentId={documentId}
              isAllRequiredSet={goNextStep}
              etichettePersonalizzate={etichettePersonalizzate}
              setEtichettePersonalizzate={setEtichettePersonalizzate}
              removeEtichettePersonalizzata={removeEtichettePersonalizzata}
              setStandardTags={setStandardTags}
              standardTags={standardTags}
              isSubmit={isSubmit}
              setIsSubmit={setIsSubmit}
              dataPayload={dataPayload}
              setDataPayload={setDataPayload}
            />
          ) : null}
          {currentStep > 2 ? <LinkDocument /> : null}
        </div>
        <div
          style={{
            flex: "0 1 auto",
            marginRight: "16px",
            marginBottom: "24px",
            width: "50%"
          }}
        >
          <Preview
            accountantSelected={accountantSelected}
            accountantIdSelected={accountantIdSelected}
            companySelected={companySelected}
            clientIdSelected={clientIdSelected}
            documentId={documentId}
            myType={myType}
          />
        </div>
      </div>
      <div className="stickyButton" style={{ textAlign: "right" }}>
        <Button
          kind="secondary"
          colorScheme={"ghost"}
          onClick={resetChange}
          style={{ marginRight: "16px" }}
          className="buttonNav"
        >
          <FormattedMessage id="generic.cancel" />
        </Button>{" "}
        {currentStep === 1 ||
        (currentStep < 3 &&
          !isAllRequiredSet &&
          (tags.list.length > 0 || typeSelected !== "")) ? (
            <Button
              disabled={typeSelected === ""}
              onClick={nextStep}
              className="buttonNav"
            >
              <FormattedMessage id="generic.next" />
            </Button>
          ) : (
            <Button
              onClick={
                e => {
                  let arrayTags = [];
                  Object.keys(standardTags).forEach(function(item) {
                    arrayTags.push({
                      value:
                      typeof standardTags[item] === "object"
                        ? standardTags[item].value
                        : standardTags[item],
                      key:
                      standardTags[item] &&
                      standardTags[item].hasOwnProperty("key")
                        ? standardTags[item].key
                        : item
                    });
                  });

                  let dataPayload = {
                    documentId: documentId,
                    documentTypeName: typeSelected,
                    tags: etichettePersonalizzate,
                    kvags: arrayTags,
                    linkedDocuments: []
                  };
                  setIsSubmit(true);
                  setDataPayload(dataPayload);
                }
              /* this.formRef
                ? this.formRef.handleSubmit.bind(this, dataPayload)
                : null*/
              }
              className="buttonNav gs-documents-detail-save-classificator"
            >
              <FormattedMessage id="generic.save" />
            </Button>
          )}
      </div>
    </div>
  ) : null;
};

export default Classificator;
